import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Image, StyleSheet, Platform, View } from 'react-native';

import UserInfoForm from '../../components/register/UserInfoForm';
import Colors from '../../constants/Colors';
import Layout from '../../constants/Layout';
import Languages from '../../constants/Languages';
import { capitalize } from '../../utils/stringFunctions';
import getInstallationIdAsync from '../../utils/getInstallationIdAsync';
import * as Actions from '../../store/Actions';
import Header from '../../components/register/Header';
import MyScrollView from '../../components/MyScrollView';

class UserDetailsScreen extends Component {
  static propTypes = {
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
    navigation: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  constructor(props) {
    super();
    this.state = {
      selectedIndex: 0,
    };
  }

  goBack = () => {
    const { actions, navigation } = this.props;
    actions.logout();
    navigation.navigate('Language');
  };

  submitDetails = async (user, locale) => {
    const { registration, navigation, actions } = this.props;
    const { onboarding } = registration;
    Languages.languages.forEach((langObject) => {
      if (langObject.name === locale) {
        user.language = langObject.full;
      }
    });
    user.device_os = Platform.OS;
    user.device_id = await getInstallationIdAsync();
    user.phone = registration?.phone;
    actions.updateUser(user);
    navigation.navigate('FamilyDetails');
  };

  render() {
    const { registration, actions } = this.props;
    const { language } = registration;
    const locale = language?.name || 'en';
    const translation = Languages.translations[locale];
    const tellUs = translation.fragment_registration_personal_textview_title;

    const submitDetails = (user) => {
      this.submitDetails(user, locale);
    };

    return (
      <MyScrollView
        containerStyle={styles.containerStyle}
        contentContainerStyle={styles.contentContainerStyle}
        compressHeight={0.95}
      >
        <Header title={capitalize(tellUs)} goBack={this.goBack} />
        <View style={styles.centerContainer}>
          <View style={styles.welcomeContainer}>
            <Image source={require('../../assets/images/tell_us.png')} style={styles.welcomeImage} />
          </View>
          <View style={styles.getStartedContainer}>
            <UserInfoForm
              translation={translation}
              locale={locale}
              goBack={this.goBack}
              goNext={submitDetails}
              registration={registration}
            />
          </View>
        </View>
      </MyScrollView>
    );
  }
}

const styles = StyleSheet.create({
  containerStyle: {
    backgroundColor: Colors.mediumBlue,
  },
  contentContainerStyle: {
    backgroundColor: Colors.lightBackground,
    alignItems: 'center',
  },
  centerContainer: {
    flex: 1,
    backgroundColor: Colors.white,
    alignItems: 'center',
    maxWidth: 720,
    width: '100%',
  },
  welcomeContainer: {
    alignItems: 'center',
    backgroundColor: Colors.backgroundBlue,
    maxWidth: Layout.mobile - 200,
    width: '100%',
  },
  welcomeImage: {
    height: 184,
    width: '100%',
    resizeMode: 'contain',
    marginTop: 3,
  },
  getStartedContainer: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'stretch',
    maxWidth: Layout.mobile - 200,
    width: '100%',
    marginBottom: 16,
  },
});

function mapStateToProps(state) {
  return {
    registration: state.registration,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserDetailsScreen);
